<template>
  <div class="about" ref='vantaRef'>
    <div class="content">
      <div class="left">
        <Myself style="margin-bottom: 30px;" />
        <SideContent title="友情链接" style="margin-bottom: 30px;border-radius: 12px;"/>
        <SideContent title="关注我" style="border-radius: 12px;"/>
      </div>
      <div class="right" >
        <el-card style="border-radius: 24px;overflow: hidden;">
          <Introduce :content="content"/>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
  import Myself from '../../components/Myself.vue'
  import SideContent from '../../components/SideContent.vue'
  import Introduce from './components/introduce.vue'
  import {animateBg} from '../../utils/mixins.js'
  export default{
    components:{
      Myself,
      SideContent,
      Introduce
    },
    data(){
      return {
        content:''
      }
    },
    mounted() {
      this.getUser()
    },
    mixins:[animateBg],
    methods:{
      async getUser(){
        const timestamp = Date.now()
        const res = await this.$api.getUserInfo({t:'json',timestamp})
        if(res.code == 200){
          this.content = res.data.content
        }else{
          console.log('error')
        }
      }
    }
  }
</script>

<style lang="scss">
  html,body{
    background-color: #F5F7FA;
  }
  .about{
   background-color: #F5F7FA;
   margin-top: 20px;
   height: calc(100vh - 120px);
    .content{
      display: flex;
      justify-content: space-between;
      background-color: rgba(999, 999, 999, .6);
      // min-height: calc(100vh - 129px - 20px);
      width: 60%;
      margin: 0 auto;
      .right{
        width: 68%;
        margin-right: 20px;
        position: relative;
        height:calc(100vh - 122px);
        overflow-y: scroll;
        overflow-x: hidden;
      }
      .left{
        width: 28%;
        margin-left: 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/about/about.vue